import * as THREE from 'three';

export class PolygonClipVolume extends THREE.Object3D {
  static counter = 0;

  camera: THREE.Camera;
  viewMatrix: THREE.Matrix4;
  projMatrix: THREE.Matrix4;
  markers: THREE.Mesh[] = [];
  initialized = false;
  enabled?: boolean;

  constructor(camera: THREE.Camera) {
    super();

    PolygonClipVolume.counter++;
    this.name = 'polygon_clip_volume_' + PolygonClipVolume.counter;

    this.camera = camera.clone();
    this.camera.rotation.set(...camera.rotation.toArray());
    (this.camera as any).rotation.order = camera.rotation.order;
    this.camera.updateMatrixWorld();
    (this.camera as THREE.PerspectiveCamera).updateProjectionMatrix?.();
    this.camera.matrixWorldInverse.copy(this.camera.matrixWorld).invert();

    this.viewMatrix = this.camera.matrixWorldInverse.clone();
    this.projMatrix = (this.camera as THREE.PerspectiveCamera).projectionMatrix.clone();
  }

  addMarker(): void {
    const marker = new THREE.Mesh();

    let cancel: () => void;

    const drag = (e: any) => {
      const size = e.viewer.renderer.getSize(new THREE.Vector2());
      const projectedPos = new THREE.Vector3(
        2.0 * (e.drag.end.x / size.width) - 1.0,
        -2.0 * (e.drag.end.y / size.height) + 1.0,
        0,
      );
      marker.position.copy(projectedPos);
    };

    const drop = () => {
      cancel();
    };

    cancel = () => {
      (marker as any).removeEventListener('drag', drag);
      (marker as any).removeEventListener('drop', drop);
    };

    (marker as any).addEventListener('drag', drag);
    (marker as any).addEventListener('drop', drop);

    this.markers.push(marker);
  }

  removeLastMarker(): void {
    if (this.markers.length > 0) {
      this.markers.splice(this.markers.length - 1, 1);
    }
  }
}
